export default __webpack_public_path__ + "assets/step_3.285d7db1.svg";